import { useQueryParam, NumberParam } from 'next-query-params';

const assembly = Boolean(process.env.NEXT_PUBLIC_ASSEMBLY === 'true');

export const PATHS = {
  SERVICE: '/service/',
  LOCATIONS: '/location/',
  LABOR_ONLY_NOTICE: '/labor_only_notice/',
  PROPERTIES: '/property/',
  INVENTORY: '/inventory/',
  SPECIAL_INVENTORY: '/special_inventory/',
  DATE: '/date/',
  TIME: '/time/',
  HOURLY: '/hourly/',
  PACKAGE: '/package/',
  FLEXIBILITY: '/flexibility/',
  ADDONS: '/addon/',
  CHECKOUT: '/checkout/',
  LDM_LEAD: '/ldm_lead/',
  LDM_LEAD_CONFIRMATION: '/ldm_lead_confirmation/',
  LEAD: '/lead/',
  LEAD_CONFIRMATION: '/lead_confirmation/',
  ADMIN_CONFIRMATION: '/confirmation/',
  REDIRECTING: '/redirecting/',
};

// show 'book/confirmation' if assembly app or push to dashboard if a customer.
const ORDER_BOOKED = assembly ? PATHS.ADMIN_CONFIRMATION : `${process.env.NEXT_PUBLIC_DASHBOARD_SITE_URL}`;

// Flow 0
export const MOVING_SERVICES_FLOW_INDEX = 0;
const MOVING_SERVICES_FLOW = [
  PATHS.SERVICE,
  PATHS.LOCATIONS,
  PATHS.PROPERTIES,
  PATHS.INVENTORY,
  PATHS.SPECIAL_INVENTORY,
  PATHS.DATE,
  PATHS.TIME,
  PATHS.PACKAGE,
  PATHS.FLEXIBILITY,
  PATHS.ADDONS,
  PATHS.CHECKOUT,
  ORDER_BOOKED,
];

// Flow 1
export const LABOR_ONLY_FLOW_INDEX = 1;
const LABOR_ONLY_FLOW = [
  PATHS.SERVICE,
  PATHS.LOCATIONS,
  PATHS.DATE,
  PATHS.TIME,
  PATHS.HOURLY,
  PATHS.FLEXIBILITY,
  PATHS.CHECKOUT,
  ORDER_BOOKED,
];

// Flow 2
export const LONG_DISTANCE_FLOW_INDEX = 2;
const LONG_DISTANCE_FLOW = [
  PATHS.SERVICE,
  PATHS.LOCATIONS,
  PATHS.DATE,
  PATHS.TIME,
  PATHS.LDM_LEAD,
  PATHS.LDM_LEAD_CONFIRMATION,
];

// Flow 3
export const LEAD_FLOW_INDEX = 3;
const LEAD_FLOW = [PATHS.SERVICE, PATHS.LOCATIONS, PATHS.LEAD, PATHS.LEAD_CONFIRMATION];

// Flow 5
export const ELIGIBLE_LEAD_FLOW_INDEX = 5;
const ELIGIBLE_LEAD_FLOW = [
  PATHS.SERVICE,
  PATHS.LOCATIONS,
  PATHS.PROPERTIES,
  PATHS.INVENTORY,
  PATHS.SPECIAL_INVENTORY,
  PATHS.DATE,
  PATHS.TIME,
  PATHS.LEAD,
  PATHS.LEAD_CONFIRMATION,
];

// Flow 4
export const LEAD_LABOR_ONLY_FLOW_INDEX = 4;
const LEAD_LABOR_ONLY_FLOW = [PATHS.SERVICE, PATHS.LOCATIONS, PATHS.DATE, PATHS.TIME, PATHS.LEAD, PATHS.LEAD_CONFIRMATION];

// continue with movers only service from labor only notice page
// Flow 6
export const LABOR_ONLY_MARKET_FLOW_INDEX = 6;
const LABOR_ONLY_MARKET_FLOW = [
  PATHS.SERVICE,
  PATHS.LOCATIONS,
  PATHS.LABOR_ONLY_NOTICE,
  PATHS.PROPERTIES,
  PATHS.INVENTORY,
  PATHS.SPECIAL_INVENTORY,
  PATHS.DATE,
  PATHS.TIME,
  PATHS.PACKAGE,
  PATHS.FLEXIBILITY,
  PATHS.ADDONS,
  PATHS.CHECKOUT,
  ORDER_BOOKED,
];

// Submit lead "be notified when we have movers in your area"
// Flow 7
export const LABOR_ONLY_MARKET_TO_LEAD_FLOW_INDEX = 7;
const LABOR_ONLY_MARKET_TO_LEAD_FLOW = [
  PATHS.SERVICE,
  PATHS.LOCATIONS,
  PATHS.LABOR_ONLY_NOTICE,
  PATHS.LEAD,
  PATHS.LEAD_CONFIRMATION,
];

// Flow 8
export const STORAGE_PROPERTY_TYPE_FLOW_INDEX = 8;
const STORAGE_PROPERTY_TYPE_FLOW = [
  PATHS.SERVICE,
  PATHS.LOCATIONS,
  PATHS.PROPERTIES,
  PATHS.DATE,
  PATHS.TIME,
  PATHS.PACKAGE,
  PATHS.FLEXIBILITY,
  PATHS.ADDONS,
  PATHS.CHECKOUT,
  ORDER_BOOKED,
];

// Flow 9
export const MLC_AVAILABILITY_FLOW_INDEX = 9;
const MLC_AVAILABILITY_FLOW = [PATHS.SERVICE, PATHS.LOCATIONS, PATHS.DATE, PATHS.REDIRECTING];

// Flow 10
export const STORAGE_PROPERTY_TYPE_LABOR_ONLY_MARKET_FLOW_INDEX = 10;
const STORAGE_PROPERTY_TYPE_LABOR_ONLY_MARKET_FLOW = [
  PATHS.SERVICE,
  PATHS.LOCATIONS,
  PATHS.LABOR_ONLY_NOTICE,
  PATHS.PROPERTIES,
  PATHS.DATE,
  PATHS.TIME,
  PATHS.PACKAGE,
  PATHS.FLEXIBILITY,
  PATHS.ADDONS,
  PATHS.CHECKOUT,
  ORDER_BOOKED,
];

const FLOWS = [
  MOVING_SERVICES_FLOW,
  LABOR_ONLY_FLOW,
  LONG_DISTANCE_FLOW,
  LEAD_FLOW,
  LEAD_LABOR_ONLY_FLOW,
  ELIGIBLE_LEAD_FLOW,
  LABOR_ONLY_MARKET_FLOW,
  LABOR_ONLY_MARKET_TO_LEAD_FLOW,
  STORAGE_PROPERTY_TYPE_FLOW,
  MLC_AVAILABILITY_FLOW,
  STORAGE_PROPERTY_TYPE_LABOR_ONLY_MARKET_FLOW,
];

const Flow = () => {
  const [flow] = useQueryParam('flow', NumberParam);
  return FLOWS[flow || 0]; // default to moving services flow
};

export default Flow;
